import { z } from "zod";
import { BaseAgentFormSchema } from "./base";
import { AgentHoursSchema } from "../modules/hours";
import { zPhoneNumber } from "../validations/phone-number-validator";
import { BillingStyle } from "@/types/base";
import { voicemailEmailValidation } from "../validations/voicemail";

export const MAX_FAQS = 30;

export const PatchAgentFormSchema = BaseAgentFormSchema.extend({
  id: z.string().optional(),
  slug: z.string().optional(),
  phoneNumber: zPhoneNumber.nullable().optional(),
  hoursLoman: AgentHoursSchema.nullable().optional(),
  disallowClosedTransfers: z.boolean().optional(),
  faqs: z
    .array(
      z.object({
        id: z.string().optional(),
        question: z.string().trim().min(1, "Question is required."),
        answer: z.string().trim().min(1, "Answer is required."),
      }),
    )
    .max(MAX_FAQS, "Maximum number of FAQs reached")
    .optional(),
  productId: z.string().nullable().optional(),
  subscriptionItemId: z.string().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  deletedAt: z.string().nullable().optional(),
  pausedUntil: z.string().nullable().optional(),
  allowAnon: z.boolean().default(false).optional(),
  panic: z.boolean().optional(),
  billingStyle: z
    .enum(Object.values(BillingStyle) as [BillingStyle, ...BillingStyle[]])
    .nullable()
    .optional(),
  stripeCustomerId: z.string().nullable().optional(),
  stripeSubscriptionId: z.string().nullable().optional(),
  introAuoUrl: z.string().nullable().optional(),
  startedAt: z.string().nullable().optional(),
})
  .refine(voicemailEmailValidation, {
    message: "Email is required for voicemail agents",
    path: ["voicemailEmail"],
  })
  .refine(
    (data) => {
      // If agent type includes DELIVERY, delivery fields are required
      if (data.type.includes("DELIVERY")) {
        // Check delivery radius
        if (data.deliveryRadius == null || data.deliveryRadius < 0.0) {
          return false;
        }

        // Check delivery fee
        if (data.deliveryFee == null || data.deliveryFee < 0) {
          return false;
        }

        // Check delivery location
        if (data.deliveryLatitude == null || data.deliveryLongitude == null) {
          return false;
        }

        // Check delivery region code
        if (
          data.deliveryRegionCode == null ||
          data.deliveryRegionCode.trim() === ""
        ) {
          return false;
        }

        return true;
      }
      return true;
    },
    {
      message:
        "Delivery location, radius, and fee are required for delivery agents",
      path: [
        "deliveryFee",
        "deliveryRadius",
        "deliveryLatitude",
        "deliveryLongitude",
        "deliveryRegionCode",
      ],
    },
  );
